import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v4CustomersGeocode } from "@be-miniapp/api"
import type { Location } from "@be-miniapp/types"

import type { RideLocation } from "../stores/ride-data"
import { usePointsOfInterest } from "./use-points-of-interest"

export function useLocationData(params: {
  center: Location | null
  defaultPickup?: RideLocation
  enabled: boolean
}) {
  const { center, defaultPickup, enabled } = params

  const { data: geocodeData, isPending: isGeocodePending } = useQuery({
    queryKey: [
      "location-geocode",
      center?.latitude,
      defaultPickup?.location?.latitude,
      center?.longitude,
      defaultPickup?.location?.longitude,
    ],
    queryFn: async () => {
      const latitude =
        center?.latitude ?? defaultPickup?.location?.latitude ?? 0
      const longitude =
        center?.longitude ?? defaultPickup?.location?.longitude ?? 0

      return v4CustomersGeocode({
        latitude,
        longitude,
        location: { latitude, longitude },
      })
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  })

  const { nearbyPickups, isPending: isPOIsPending } = usePointsOfInterest({
    point: center,
  })

  return {
    geocodeData,
    nearbyPickups: nearbyPickups?.data ?? [],
    isLoading: isGeocodePending || isPOIsPending,
  }
}
